module.exports = __webpack_public_path__ + "img/MN_250x250.de59d4f1.svg";